import axios from "/@/utils/request";

const api = {
  socialAccountList: "/console/v1/socialAccount/list",
  session: "/console/v1/session/start",
  qrcode: "/console/v1/session/getQRCode",
  terminate: "/console/v1/socialAccount/terminate",
  delect: "/console/v1/socialAccount/delete",
  settingSeat: "/console/v1/socialAccount/seatSettings",
  log: "/console/v1/socialAccountLog/list",
};

const getSocialAccountList = (params: any) => {
  return axios({
    url: api.socialAccountList,
    method: "get",
    params,
  });
};
// 打开会话
const openSession = (data: any) => {
  return axios({
    url: api.session,
    method: "post",
    data,
  });
};
// 获取二维码
const getQRcode = (data: any) => {
  return axios({
    url: api.qrcode,
    method: "post",
    data,
  });
};
// 强制下线
const acountTerminate = (data: any) => {
  return axios({
    url: api.terminate,
    method: "post",
    data,
  });
};
// 删除社交账号
const delectAccount = (data: any) => {
  return axios({
    url: api.delect,
    method: "post",
    data,
  });
};
// 设置账号归属席位
const settingAccountSeat = (data: any) => {
  return axios({
    url: api.settingSeat,
    method: "post",
    data,
  });
};
// 账号日志
const getLogList = (params: any) => {
  return axios({
    url: api.log,
    method: "get",
    params,
  });
};
export {
  getSocialAccountList,
  openSession,
  getQRcode,
  acountTerminate,
  delectAccount,
  settingAccountSeat,
  getLogList,
};
